import { Injectable } from "@angular/core";
import { IEquity, IFli, IFreeTable, IMovementScheduleFli, INotesSelectComponent, ISuperTableComponent, Notes } from "@modeso/types__aumico-lib-annualreport-be";
import { IDynamicKeyValue } from "@modeso/types__aumico-lib-core-be";
import { ComponentType } from "@modeso/types__aumico-lib-notes-be";
import { cloneDeep } from 'lodash-es';
import { EMPTY_ARRAY_LENGTH, FIRST_ELEMENT_INDEX } from "../../../../aumico-lib-core-fe/src/lib";
import { NotesEmptyLinesRemovalHelper } from "./notesEmptyLinesRemoval.helper";


@Injectable({ providedIn: 'root' })
export class ComponentsEmptyDeterminatorHelper {
    constructor(private notesEmptyLinesRemovalHelper: NotesEmptyLinesRemovalHelper) { }


    public isComponentConsideredEmpty(componentName: ComponentType, data: Notes, language: string): boolean {
        // First check if component has no rows at all
        const isComponentCompletelyEmpty = this.notesEmptyLinesRemovalHelper.isComponentDataEmpty(
            componentName,
            data,
            language,
        );
        if (isComponentCompletelyEmpty) {
            return true;
        }
        // Then try removing empty lines
        const componentWithRemovedEmptyLines = cloneDeep<Notes>(
            this.notesEmptyLinesRemovalHelper.removeEmptyLinesOfComponents(componentName, data),
        );

        // Then check again after removing empty lines
        return this.notesEmptyLinesRemovalHelper.isComponentDataEmpty(
            componentName,
            componentWithRemovedEmptyLines,
            language,
        );
    }


    public isTableDataEmpty(componentType: ComponentType, tableData: Notes): boolean {
        switch (componentType) {
            case ComponentType.FREE_TABLE_WITH_AMOUNTS: {
                return (tableData as IFreeTable).rows.length === EMPTY_ARRAY_LENGTH;
            }
            case ComponentType.EQUITY: {
                return (tableData as IEquity).rows.length === EMPTY_ARRAY_LENGTH;
            }
            case ComponentType.SELECT: {
                return (
                    (tableData as INotesSelectComponent).options.text == null &&
                    (tableData as INotesSelectComponent).options.title === null &&
                    (tableData as INotesSelectComponent).previousYearValue == null &&
                    (tableData as INotesSelectComponent).currentYearValue == null
                );
            }
            case ComponentType.SUPER_TABLE: {
                return (tableData as ISuperTableComponent).rows.length == EMPTY_ARRAY_LENGTH;
            }

            default:
                return true;
        }
    }

    public isFliTableDataEmpty(fli: IFli): boolean {
        return (
            fli.accounts == null ||
            fli.accounts.length === EMPTY_ARRAY_LENGTH ||
            fli.accounts[FIRST_ELEMENT_INDEX].id === ''
        );
    }

    public isMovementScheduleFliTableDataEmpty(fli: IMovementScheduleFli): boolean {
        return fli.accounts == null || fli.accounts.length === EMPTY_ARRAY_LENGTH;
    }

    public isPropertyEmpty(prop: IDynamicKeyValue | undefined): boolean {
        if (prop == null) {
            return true;
        }

        for (const value of Object.values(prop)) {
            if (value != null && value !== '') {
                return false;
            }
        }

        return true;
    }
}